/**
 * Vue and Vue modules
 */

window.Vue = require('vue');

// Função para facilitar redirects usando os nomes das rotas do Laravel
// IMPORTANT: 'needRoutes = true' habilita a definição da função 'route()' em `resources/views/layouts/master.blade.php`
Vue.prototype.$redirect = (name, isUrl = false) => {
    if(! isUrl) {
        name = route(name);
    }
    window.location.href = name;
};

// Função para obter uma rota da API abstraindo a versão atual
Vue.prototype.$apiRoute = (name, extra = null) => route(`api.v${process.env.NODE_ENV === 'production' ? window._env_.MIX_API_VERSION : process.env.MIX_API_VERSION}.${name}`, extra);

// Função para criar um URL que possua argumentos
import Arg from 'GlobalTools/Arg';
Vue.prototype.$urlArg = (url, args = {}) => {
    if(args !== {}) {
        const arg = new Arg;
        for(const field in args) {
            if(typeof(args[field]) !== 'string') {
                args[field] = JSON.stringify(args[field]);
            }
        }
        url = arg.url(url, args);
    }
    return url;
};

// Cria uma instancia global para enviar e receber eventos entre componentes Vue
window.VueListener = new class {
    constructor() {
        this.vue = new Vue();
    }

    // Interface para enviar um evento para outra instância Vue
    fire(event, ...args) {
        // https://stackoverflow.com/a/39050570/1686131
        this.vue.$emit(event, ...args);
    }

    // Interface para esperar por um evento
    listen(event, callback) {
        this.vue.$on(event, callback);
    }
};


/**
 * Ferramentas úteis
 */

// Classe para facilitar a cópia de objetos quando o novo não pode referenciar o antigo
import Clone from 'GlobalTools/Clone';
window.Clone = Clone;

// Formulário para abstrair o Axios
import Http from 'GlobalTools/Http';
window.AxiosForm = Http;

// Funções para manipulação de texto
import TextTransform from 'GlobalTools/TextTransform';
window.TextTransform = TextTransform;

// Funções para facilitar testes
import Test from 'GlobalTools/Test';
window.Test = Test;

// Recarrega a página toda vez que history.back é detectado (botão back do browser)
window.onpopstate = () => {
    location.reload();
};

/**
 * Pacotes do NPM
 */
// [moment] https://momentjs.com/docs/
// window.moment = require('moment');


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios').default;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');
if(token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else if(process.env.NODE_ENV === 'production') {
    // IMPORTANT: CSRF Token não funciona em desenvolvimento e isso é esperado. Desabilite-o em 'app/Http/Kernel.php'
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'); // eslint-disable-line
}

// O código abaixo intercepta o request feito pelo Axios antes dele ser enviado e após a resposta ser recebida.
// Serve para fazer o log dos erros usando, entre outros, o Sentry

// Add a request interceptor
window.axios.interceptors.request.use(
    // Do something before request is sent
    (config) => {
        if(config.headers === null) {
            config.headers = {};
        }
        config.headers['Accept'] = 'application/json'; // skipcq: JS-0049
        config.headers['X-Requested-With'] = 'XMLHttpRequest'; // skipcq: JS-0049

        const destination = TextTransform.parseUrl(String(config.url));
        if('host' in destination) {
            const origin = TextTransform.parseUrl(String(location.origin));
            if(origin.host !== destination.host) {
                /**
                 * CORS
                 */
                config.headers['Access-Control-Allow-Origin'] = '*';
            }
        }
        return config;
    },
    // Do something with request error
    (error) => Promise.reject(error)
);

// Add a response interceptor
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if(process.env.NODE_ENV !== 'production' && error.response.status === 419) {
            // eslint-disable-next-line
            console.error('CSRF Token não funciona com o proxy criado pelo Vue / browserSync');
        }
        return Promise.reject(error);
    }
);


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
